import { ThemeProvider } from "../portal/ThemeProvider";

interface Props {
  children: React.ReactNode;
}

export const AccreditationPortalLayout = ({ children }: Props) => {
  return <ThemeProvider>{children}</ThemeProvider>;
};
